export const getFormateDate = (timestamp, format = 'yy-MM-dd hh-mm-ss', withZero = true) => {
    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    const now = new Date();
    if (
        now.getFullYear() === year &&
        now.getMonth() + 1 === month &&
        now.getDate() === day &&
        /today/.test(format)
    ) {
        return '今天';
    }
    if (
        now.getFullYear() === year &&
        now.getMonth() + 1 === month &&
        now.getDate() === day + 1 &&
        /yesterday/.test(format)
    ) {
        return '昨天';
    }

    format = format.replace(/today/, '');
    format = format.replace(/yesterday/, '');
    const addPrefix = (num) => (num < 10 && withZero ? `0${num}` : num);
    return format
        .replace(/y+/, addPrefix(year))
        .replace(/M+/, addPrefix(month))
        .replace(/d+/, addPrefix(day))
        .replace(/h+/, addPrefix(hour))
        .replace(/m+/, addPrefix(minute))
        .replace(/s+/, addPrefix(second));
};
